import { createProfessionalExporter } from '../../../utils/professionalExport';
import { getGymMemberId, getMemberCreatedAt } from '../../admin/members/memberData';

const headers = ['Serial No', 'Name', 'Email', 'Mobile', 'Created At'];

const exporter = createProfessionalExporter({
  title: 'Member List',
  headers,
  slug: 'members',
  getRows: (memberList) =>
    memberList.map((member) => [
      getGymMemberId(member) || '—',
      member.name,
      member.email,
      member.mobile || member.phone,
      getMemberCreatedAt(member),
    ]),
  getSummary: (memberList) => [`Total members: ${memberList.length}`],
});

export const printMemberList = (data) => exporter.print(data);
export const exportMemberCsv = (data) => exporter.csv(data);
export const exportMemberExcel = (data) => exporter.excel(data);
export const exportMemberPdf = (data) => exporter.pdf(data);
export const exportMembers = (data) => exporter.export(data);
